import React, { useState } from 'react';
import { Button } from './ui/button';
import { Play, Users, Calendar } from 'lucide-react';
import AnimatedSection from './AnimatedSection';
import StaggeredList from './StaggeredList';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoadingSample] = useState(false);

  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  const handleScheduleDemo = () => {
    window.location.href = '/trial-request';
  };

  const handleRequestSample = async () => {
    window.location.href = '/sample-request';  
  };

  const getYouTubeEmbedUrl = (videoId) => {
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
  };

  const quickLinks = [
    { time: '0:00', title: 'Product Overview', description: 'Introduction to Cordflex' },
    { time: '1:30', title: 'Installation Demo', description: '<30-second setup process' },
    { time: '2:45', title: 'Clinical Results', description: 'Real-world outcomes' }
  ];

  return (
    <section id="video-section" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#214140' }}>
              See Cordflex in Action
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Watch how Cordflex transforms ICU line management in real-world scenarios
            </p>
          </div>
        </AnimatedSection>

        <div className="max-w-4xl mx-auto">
          {/* Video Player */}
          <AnimatedSection animation="scale-up" delay={200}>
            <div className="relative aspect-video bg-gray-100 rounded-2xl overflow-hidden shadow-2xl mb-8">
              {!isPlaying ? (
                <>
                  {/* YouTube Thumbnail */}
                  <img
                    src="https://img.youtube.com/vi/uxTUu8HbrEg/maxresdefault.jpg"
                    alt="Cordflex Demo Video"
                    className="absolute inset-0 w-full h-full object-cover"
                  />

                  {/* Play Button Overlay */}
                  <button
                    onClick={handlePlayVideo}
                    className="absolute inset-0 flex items-center justify-center group hover:bg-black/10 transition-colors duration-200"
                  >
                    <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                      <div className="w-20 h-20 rounded-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300" style={{ backgroundColor: '#214140' }}>
                        <Play className="h-10 w-10 text-white ml-1" />
                      </div>
                    </div>
                  </button>
                </>
              ) : (
                <iframe
                  src={getYouTubeEmbedUrl('uxTUu8HbrEg')}
                  title="Cordflex Demo Video"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </AnimatedSection>


          {/* CTA Buttons */}
          <AnimatedSection animation="fade-up" delay={500}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={handleRequestSample}
                disabled={isLoadingSample}
                size="lg"
                className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-all duration-200 transform hover:scale-105"
                style={{ backgroundColor: '#214140', color: 'white' }}
              >
              Request Your Sample Kit
              </Button>
              <Button
                onClick={handleScheduleDemo}
                variant="outline"
                size="lg"
                className="px-8 py-4 text-lg font-semibold border-2 hover:bg-teal-50 transition-all duration-200 transform hover:scale-105"
                style={{ borderColor: '#214140', color: '#214140' }}
              >
                Request a Trial
              </Button>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;